<template>
    <Layout sub="custom">
        <section class="flex flex-col">
            <!-- Report Menu -->
            <div class="flex flex-row w-full justify-between items-center">
                <div class="flex flex-col w-1/2">
                    <input class="w-full text-semibold text-[24px] hover:border-0 focus:ring-0 focus:border-0 border-0 bg-transparent" placeholder="Custom report name" v-model="form.name" type="text" name="name">
                    <input class="w-full border-0 hover:border-0 focus:ring-0 focus:border-0 bg-transparent text-[12px] text-base" placeholder="Enter a description" v-model="form.description" type="text"
                           name="description">
                </div>
                <div class="flex flex-row space-x-[12px]">
                    <button @click="exportCSV" type="button"
                            class="inline-flex transition ease-in-out duration-300 space-x-[4px] items-center px-8 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-black bg-white hover:text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                        <svg class="h-[22px] w-[22px] fill-current" viewBox="0 0 20.257 22.5">
                            <path id="Path_312" data-name="Path 312"
                                  d="M63.348,5.273v6.855a.879.879,0,1,0,1.758,0V5.273A5.279,5.279,0,0,0,59.832,0H51.746a5.279,5.279,0,0,0-5.273,5.273v6.855a.879.879,0,0,0,1.758,0V5.273a3.52,3.52,0,0,1,3.516-3.516h8.086A3.52,3.52,0,0,1,63.348,5.273Z"
                                  transform="translate(-45.552)"/>
                            <path id="Path_313" data-name="Path 313"
                                  d="M270.922,84.57a.879.879,0,0,0-.879-.879h-1.494a1.32,1.32,0,0,1-1.318-1.318V80.879a.879.879,0,0,0-1.758,0v1.494a3.08,3.08,0,0,0,3.076,3.076h1.494A.879.879,0,0,0,270.922,84.57Z"
                                  transform="translate(-254.928 -76.484)"/>
                            <path id="Path_314" data-name="Path 314"
                                  d="M186.393,333.119c-.615,0-1.079-.293-1.079-.681a.7.7,0,0,1,.707-.681,4.746,4.746,0,0,1,1.749.382.879.879,0,0,0,.626-1.643,6.587,6.587,0,0,0-2.374-.5,2.455,2.455,0,0,0-2.465,2.439,2.6,2.6,0,0,0,2.837,2.439c.512,0,.944.312.944.681a.742.742,0,0,1-.758.681,5.826,5.826,0,0,1-1.912-.38.879.879,0,1,0-.638,1.638,7.642,7.642,0,0,0,2.549.5,2.543,2.543,0,0,0,1.751-.7,2.38,2.38,0,0,0,.764-1.742A2.583,2.583,0,0,0,186.393,333.119Z"
                                  transform="translate(-176.528 -315.497)"/>
                            <path id="Path_315" data-name="Path 315"
                                  d="M346.209,330.019a.879.879,0,0,0-1.058.652l-1.277,5.37c-.046.128-.121.2-.22.2h0c-.1,0-.176-.071-.221-.2l-1.228-5.359a.879.879,0,0,0-1.713.393l1.236,5.4c0,.02.01.04.016.06a1.99,1.99,0,0,0,1.9,1.467h.008a1.988,1.988,0,0,0,1.9-1.451q.009-.029.016-.059l1.286-5.406A.879.879,0,0,0,346.209,330.019Z"
                                  transform="translate(-326.628 -315.493)"/>
                            <path id="Path_316" data-name="Path 316"
                                  d="M28.447,330.758a1.123,1.123,0,0,1,1.138.854.879.879,0,1,0,1.714-.391A2.885,2.885,0,0,0,28.447,329a2.928,2.928,0,0,0-2.925,2.925v2.148A2.928,2.928,0,0,0,28.447,337a2.89,2.89,0,0,0,2.849-2.165.879.879,0,1,0-1.708-.416,1.125,1.125,0,0,1-1.141.823,1.168,1.168,0,0,1-1.167-1.167v-2.148A1.168,1.168,0,0,1,28.447,330.758Z"
                                  transform="translate(-25.522 -314.542)"/>
                        </svg>
                        <span>Export CSV</span>
                    </button>
                    <Link href="/reports" type="button"
                          class="inline-flex space-x-[4px] items-center px-8 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-black bg-white ">
                        <span>Cancel</span>
                    </Link>
                    <button @click="save" type="button"
                            class="inline-flex transition ease-in-out duration-300 space-x-[4px] items-center px-8 py-2 border border-transparent shadow-sm text-[14px] font-semibold rounded-md text-white bg-face-red hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-700">
                        <span>Save and close</span>
                    </button>
                </div>
            </div>

            <!-- Filters -->
            <div class="flex relative flex-row bg-white items-start border-[1px] border-[#f3f3f3] px-[20px] py-[20px] min-h-[120px] space-x-[20px] mt-[20px] rounded-[8px] ">
                <div class="flex flex-col space-y-4">
                    <AddFilter class="w-[200px]" :selected="{id: 1, name: 'Add Filter'}" @selection="handleSelection"/>
                    <button @click="applyFilter" class="bg-green-500 hover:bg-green-700 transition ease-out-out duration-300 shadow-lg shadow-green-500/50 hover:shadow-green-700/50 text-white rounded-md px-4 py-[6px]">
                        Apply
                    </button>
                </div>
                <div v-if="showFilter" class="flex w-full absolute top-0 left-[120px] z-10 ">
                    <InputPanel v-if="currentFilter.component === 'InputPanel'" :filter="currentFilter" @cancel="handleCancel" @apply="handleSelectedFilter"/>
                    <StatusList v-if="currentFilter.component === 'StatusList'" :filter="currentFilter" @cancel="handleCancel" @apply="handleSelectedFilter"/>
                    <InternalStatusList v-if="currentFilter.component === 'InternalStatusList'" :filter="currentFilter" @cancel="handleCancel" @apply="handleSelectedFilter"/>
                </div>
                <div class="flex flex-row flex-wrap space-x-[20px] items-center flex-start ">
                    <ul role="list" class="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                        <li v-for="filter in form.filters" :key="filter.id" class="col-span-1 flex bg-black-haze rounded-md px-[8px] py-[8px] inline-flex space-x-[8px] items-center justify-between">
                            <p class="text-base text-[14px] truncate">{{ `${filter.name} ${filter.verb}` }}&nbsp;&nbsp;<span class="text-face-orange text-semibold text-[14px]">{{ filter.value }}</span></p>
                            <button type="button" @click="dismiss(filter)">
                                <svg width="15.916" height="15.916" viewBox="0 0 15.916 15.916">
                                    <g id="close-circle">
                                        <g id="Group_3" data-name="Group 3" transform="translate(4.424 4.423)">
                                            <path id="Vector" d="M.738,7.07a.733.733,0,0,1-.524-.217.745.745,0,0,1,0-1.047L5.806.215A.74.74,0,0,1,6.853,1.262L1.262,6.853A.717.717,0,0,1,.738,7.07Z"
                                                  transform="translate(0 0)"
                                                  fill="#120f20"/>
                                            <path id="Vector-2" data-name="Vector" d="M6.329,7.07a.733.733,0,0,1-.524-.217L.215,1.262A.74.74,0,0,1,1.262.215L6.853,5.806a.745.745,0,0,1,0,1.047A.733.733,0,0,1,6.329,7.07Z"
                                                  transform="translate(0 0)" fill="#120f20"/>
                                        </g>
                                        <path id="Vector-3" data-name="Vector" d="M0,0H15.916V15.916H0Z" fill="none" opacity="0"/>
                                    </g>
                                </svg>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Filtered Contents -->
            <div class="flex flex-row w-full min-h-[500px]">
                <!-- Left panel -->
                <div class="w-2/3 mr-4  bg-white border-[1px] border-[#f3f3f3] px-[20px] py-[20px] mt-[20px] rounded-[8px]">
                    <div v-if="form.type === 'count'" class="flex flex-col h-full w-full   ">
                        <h2 class="font-semibold text-[18px] text-black">Count</h2>
                        <h4 class="font-bold text-[50px] text-black">{{ items?.count ?? 0 }}</h4>
                    </div>
                    <div v-if="form.type === 'table'" class="flex flex-col h-full w-full ">
                        <Table :items="props.items?.table ?? []" />
                    </div>
                    <div v-if="form.type === 'chart'" class="flex flex-col h-full w-full ">
                        <LineChart :chartData="chartData" :options="{responsive: true, maintainAspectRatio: false}"/>
                    </div>
                </div>

                <!-- Right panel -->
                <div class="flex flex-col w-1/3 bg-white border-[1px] border-[#f3f3f3] px-[20px] py-[20px] mt-[20px] rounded-[8px]">
                    <h2 class="text-[18px] font-semibold text-black pb-[10px]">Display Type</h2>
                    <div>
                        <span class="relative text-[#c2cad6] z-0 inline-flex shadow-sm rounded-md">
                            <button @click="setDisplayType('count')" ref="refCount" type="button"
                                    :class="[form.type === 'count' ? 'bg-face-red text-white border-face-red' : 'text-gray-700 bg-white border-gray-300 text-[#c2cad6]']"
                                    class="relative inline-flex space-x-[6px] items-center px-4 py-2 rounded-l-md border text-sm font-medium hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:bg-face-red focus:text-white focus:ring-face-red focus:border-face-red">
                                <span>
                                  <svg aria-hidden="true" role="img" class="w-[24px] h-[24px] fill-current" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                      <path
                                          d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 2v12h7V6H4m16 12V6h-1.24c.24.54.19 1.07.19 1.13c-.07.67-.54 1.37-.71 1.62l-2.33 2.55l3.32-.02l.01 1.22l-5.2-.03l-.04-1s3.05-3.23 3.2-3.52c.14-.28.71-1.95-.7-1.95c-1.23.05-1.09 1.3-1.09 1.3l-1.54.01s.01-.66.38-1.31H13v12h2.58l-.01-.86l.97-.01s.91-.16.92-1.05c.04-1-.81-1-.96-1c-.13 0-1.07.05-1.07.87h-1.52s.04-2.06 2.59-2.06c2.6 0 2.46 2.02 2.46 2.02s.04 1.25-1.11 1.72l.52.37H20M8.92 16h-1.5v-5.8l-1.8.56V9.53l3.14-1.12h.16V16z"
                                          fill="currentColor"></path>
                                  </svg>
                                </span>
                                <span>Count</span>
                            </button>
                            <button @click="setDisplayType('table')" ref="refTable" type="button"
                                    :class="[form.type === 'table' ? 'bg-face-red text-white border-face-red' : 'text-gray-700 bg-white border-gray-300 text-[#c2cad6]']"
                                    class="-ml-px relative space-x-[6px] inline-flex items-center px-4 py-2 border text-sm font-medium hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:bg-face-red focus:text-white focus:ring-face-red focus:border-face-red">
                                  <span>
                                      <svg aria-hidden="true" role="img" class="w-[24px] h-[24px] fill-current" width="32" height="32" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path
                                          d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m0 16H5V5h14v14M9 18H6v-2h3v2m4 0h-3v-2h3v2m-4-3H6v-2h3v2m4 0h-3v-2h3v2m-4-3H6v-2h3v2m4 0h-3v-2h3v2z"
                                          fill="currentColor"></path></svg>
                                </span>
                                    <span>Table</span>
                            </button>
                            <button @click="setDisplayType('chart')" ref="refChart" type="button"
                                    :class="[form.type === 'chart' ? 'bg-face-red text-white border-face-red' : 'text-gray-700 bg-white border-gray-300 text-[#c2cad6]']"
                                    class="-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border space-x-[6px] text-sm font-medium hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:bg-face-red focus:text-white focus:ring-face-red focus:border-face-red">
                                <span>
                                    <svg aria-hidden="true" role="img" class="w-[24px] h-[24px] fill-current" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path
                                        d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v14h16V5H4zm3 8h2v4H7v-4zm4-6h2v10h-2V7zm4 3h2v7h-2v-7z" fill="currentColor"></path></svg>
                                </span>
                                <span>Charts</span>
                            </button>
                        </span>
                    </div>
                    <div class="flex w-full mt-[20px]" v-if="form.type === 'table'">
                        <TableFields :form-fields="form.fields" @apply="applyTableFields"/>
                    </div>
                </div>
            </div>
        </section>
    </Layout>

</template>

<script setup>
import Layout from "@/Shared/Layout"
import Table from "@/Shared/Table"
import AddFilter from "@/Shared/AddFilter"
import InputPanel from "@/Shared/InputPanel"
import StatusList from "@/Shared/StatusList"
import InternalStatusList from "@/Shared/InternalStatusList"
import TableFields from "@/Shared/TableFields"
import {Link, useForm} from '@inertiajs/inertia-vue3'
import {onMounted, ref} from "vue";
import {LineChart} from 'vue-chart-3';
import {Chart, registerables} from "chart.js";

//const items = ref([])

const props = defineProps({report: Array})

const chartData = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'Data One',
            backgroundColor: '#ff0016',
            data: [40, 39, 10, 40, 39, 80, 40]
        }
    ]
}

const form = useForm({
    name: null,
    description: null,
    filters: [],
    type: 'count',
    fields: []
})

const refCount = ref(null)
const refTable = ref(null)
const refChart = ref(null)
const currentFilter = ref({})
const showFilter = ref(false)

const setDisplayType = (type) => {
    form.type = type
    switch (type) {
        case 'count':
            refCount.value.focus()
            break;
        case 'table':
            refTable.value.focus()
            break;
        case 'chart':
            refChart.value.focus()
            break;
    }
}
Chart.register(...registerables);


onMounted(async () => {
    const {data} = await axios.get('/reports/custom/list')
    form.name = data[0].name
    form.description = data[0].description
    form.fields = data[0].fields
    form.filters = data[0].filters
    refCount.value.focus()
})

const dismiss = async (filter) => {
    form.filters = form.filters.filter(f => f.id !== filter.id)
}
const save = async () => {
    form.post('/reports/custom/create')
}
const applyTableFields = (fields) => {
    form.fields = fields
    applyFilter()
}

const handleCancel = () => {
    showFilter.value = false
    currentFilter.value = {}
}

const handleSelectedFilter = (selection) => {
    form.filters = [...form.filters, selection]
    form.filters = form.filters.reduce((unique, item) => {
        return unique.includes(item) ? unique : [...unique, item]
    }, [])
    showFilter.value = false
    currentFilter.value = {}
}

const applyFilter = () => {
    if (form.filters.length === 0) {
        return;
    }
    form.post('/reports/custom', {onFinish: () => console.log('Finish')})
    //items.value = data.data
}

const handleSelection = (selection) => {
    currentFilter.value = selection
    showFilter.value = true
}
const exportCSV = async () => {
    try {
    } catch (e) {

    }
}
</script>
